'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldCenterPropertyForm = exports.shouldShowEmailForm = exports.getDateTimeOptions = exports.getDateOptions = exports.getGroupedAvailableTimes = exports.getAvailableStartTimes = exports.getOffline = exports.getAvailableTimePeriods = exports.getLegalConsentEnabled = exports.getCustomParams = exports.getEditLinkURL = exports.getBookInfo = exports.getMeetingLength = exports.getEvent = exports.getUserTimezone = exports.getLanguageFromSettings = exports.getLocaleFromSettings = exports.getDisplayInfo = exports.shouldFetchUserProfile = exports.getUserProfile = undefined;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _Immutable = require('Immutable');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _reselect = require('reselect');

var _FormFieldValidationSelector = require('MeetingsLib/selectors/FormFieldValidationSelector');

var _RequestStatusSelectors = require('MeetingsLib/selectors/RequestStatusSelectors');

var _GateSelectors = require('MeetingsLib/selectors/GateSelectors');

var _RequestStatusTypes = require('MeetingsBase/constants/RequestStatusTypes');

var _TimeRangeListUtils = require('MeetingsBase/utils/TimeRangeListUtils');

var _utils = require('MeetingsBase/utils/utils');

var _AvailabilityMilliseconds = require('MeetingsBase/models/AvailabilityMilliseconds');

var _AvailabilityMilliseconds2 = _interopRequireDefault(_AvailabilityMilliseconds);

var _utils2 = require('MeetingsLib/utils/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getProfileFromProps = function getProfileFromProps(state, props) {
  return (0, _get2.default)('profile', props);
};
var getProfileFromState = (0, _get2.default)('profile');
var getRoundRobinProfile = (0, _getIn2.default)(['bookingLifecycle', 'postResponse', 'organizer']);
var getForceOffline = (0, _get2.default)('forceOffline');
var getPortalId = (0, _get2.default)('portalId');

var getUserProfile = exports.getUserProfile = (0, _reselect.createSelector)([getProfileFromProps, getProfileFromState, getRoundRobinProfile], function (propsProfile, stateProfile, roundRobinProfile) {
  return propsProfile || roundRobinProfile || stateProfile;
});

var shouldFetchUserProfile = exports.shouldFetchUserProfile = (0, _reselect.createSelector)([_RequestStatusSelectors.getUserProfileFetchStatus], function (userProfileFetchStatus) {
  return userProfileFetchStatus !== _RequestStatusTypes.STARTED && userProfileFetchStatus !== _RequestStatusTypes.SUCCEEDED;
});

var getDisplayInfoProp = function getDisplayInfoProp(props) {
  return (0, _get2.default)('displayInfo', props);
};
var getDisplayInfoState = (0, _getIn2.default)(['bookInfo', 'customParams', 'displayInfo']);

var getDisplayInfo = exports.getDisplayInfo = function getDisplayInfo(state, props) {
  var propDisplayInfo = getDisplayInfoProp(props);
  var stateDisplayInfo = getDisplayInfoState(state);
  return propDisplayInfo || stateDisplayInfo;
};

var getLocaleFromSettings = exports.getLocaleFromSettings = (0, _getIn2.default)(['bookInfo', 'customParams', 'locale']);

var getLanguageFromSettings = exports.getLanguageFromSettings = (0, _getIn2.default)(['bookInfo', 'customParams', 'language']);

var getBookingLifecycle = (0, _get2.default)('bookingLifecycle');
var getBookInfoState = (0, _get2.default)('bookInfo');
var getUserTimezone = exports.getUserTimezone = (0, _get2.default)('userTimezone');

var getEvent = exports.getEvent = (0, _reselect.createSelector)([getBookingLifecycle], function (bookingLifecycle) {
  return bookingLifecycle.event;
});

var getMeetingLength = exports.getMeetingLength = (0, _reselect.createSelector)([getEvent], function (event) {
  return event.duration;
});

var getBookInfo = exports.getBookInfo = (0, _reselect.createSelector)([getBookInfoState, getDisplayInfo], function (stateBookInfo, displayInfo) {
  if (stateBookInfo) {
    return stateBookInfo.setIn(['customParams', 'displayInfo'], displayInfo);
  }
  return stateBookInfo;
});

var getEditLinkURL = exports.getEditLinkURL = (0, _reselect.createSelector)([getBookInfo, getPortalId], function (bookInfo, portalId) {
  var linkId = bookInfo.linkId,
      linkType = bookInfo.linkType;

  var linkEditParam = (0, _utils2.getLinkEditParam)(linkType);
  var baseURL = (0, _utils2.getAdminDomain)();
  return 'https://' + baseURL + '/meetings/' + portalId + '/' + linkEditParam + '/' + linkId;
});

var getCustomParams = exports.getCustomParams = (0, _reselect.createSelector)([getBookInfo], function (bookInfo) {
  return (0, _get2.default)('customParams', bookInfo);
});

var getLegalConsentEnabled = exports.getLegalConsentEnabled = (0, _reselect.createSelector)([getCustomParams], function (customParams) {
  return (0, _get2.default)('legalConsentEnabled', customParams);
});

var getAvailableTimePeriods = exports.getAvailableTimePeriods = (0, _reselect.createSelector)([getBookInfo, _RequestStatusSelectors.getIsFetchingPublicAvailability], function (bookInfo, isFetchingPublicAvailability) {
  if (isFetchingPublicAvailability) {
    return null;
  }

  var allUsersBusyTimes = bookInfo.allUsersBusyTimes,
      linkType = bookInfo.linkType,
      customParams = bookInfo.customParams;
  var availability = customParams.availability;

  var availabilityMilliseconds = _AvailabilityMilliseconds2.default.fromAvailability(availability);

  return (0, _utils.freeDateTimeRanges)({
    availability: availabilityMilliseconds,
    bookableUsersBusyTimes: allUsersBusyTimes.map(function (userBusyTimes) {
      return userBusyTimes.busyTimes;
    }),
    settings: customParams,
    linkType: linkType,
    now: (0, _utils2.getTimeAtLoad)()
  });
});

var getOffline = exports.getOffline = (0, _reselect.createSelector)([getBookInfo, getForceOffline], function (bookInfo, forceOffline) {
  return forceOffline || bookInfo.offline;
});

var getAvailableStartTimes = exports.getAvailableStartTimes = (0, _reselect.createSelector)([getBookInfo, _GateSelectors.isUngatedForFifteenMinuteStartTimes, getAvailableTimePeriods, getBookingLifecycle, getEvent, _RequestStatusSelectors.getIsFetchingPublicAvailability], function (bookInfo, ungatedForFifteenMinuteStartTimes, availableTimePeriods, bookingLifecycle, event, isFetchingPublicAvailability) {
  var availableTimes = isFetchingPublicAvailability ? (0, _Immutable.List)() : availableTimePeriods;
  var calculateStartTimes = ungatedForFifteenMinuteStartTimes ? _TimeRangeListUtils.getFifteenMinuteStartTimes : _TimeRangeListUtils.getMeetingLengthStartTimes;

  return calculateStartTimes(availableTimes, event.duration);
});

var getGroupedAvailableTimes = exports.getGroupedAvailableTimes = (0, _reselect.createSelector)([getAvailableStartTimes, getUserTimezone], function (startTimes, userTimezone) {
  return startTimes.groupBy(function (startTimestamp) {
    return _I18n2.default.moment(startTimestamp).tz(userTimezone).format('YYYY-MM-DD');
  });
});

// TODO rename dateOptions to getAvailableDates
var getDateOptions = exports.getDateOptions = (0, _reselect.createSelector)([getGroupedAvailableTimes], function (groupedAvailableTimes) {
  return groupedAvailableTimes.keySeq();
});

// TODO rename dateTimeOptions to getAvailableStartTimesForSelectedDate
var getDateTimeOptions = exports.getDateTimeOptions = (0, _reselect.createSelector)([getGroupedAvailableTimes, getEvent], function (groupedAvailableTimes, event) {
  return groupedAvailableTimes.get(event.dateString) || (0, _Immutable.List)();
});

var shouldShowEmailForm = exports.shouldShowEmailForm = (0, _reselect.createSelector)([getBookInfo, _FormFieldValidationSelector.getStagedFormState], function (bookInfo, stagedFormState) {
  return (0, _get2.default)('ownerPrioritized', bookInfo) && stagedFormState && !stagedFormState.email;
});

var shouldCenterPropertyForm = exports.shouldCenterPropertyForm = (0, _reselect.createSelector)([_FormFieldValidationSelector.getFormFields], function (formFields) {
  return formFields.isEmpty();
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/selectors/BookInfoSelectors.js
// module id = 22
// module chunks = 0